import { connect } from 'react-redux'

import {
  fetchMemberCommsPrecheckedCategories,
  clearMemberCommsPrecheckedCategories,
} from 'store/Contentful'
import {
  fetchMemberCommsPrecheckedProviders,
  clearMemberCommsPrecheckedProviders,
} from 'store/Care'
import { setSelectedSpecialty } from 'store/MemberCommunication'
import { PreCheckedProviders as BasePreCheckedProviders } from './PreCheckedProviders'

const mapStateToProps = ({ Care, Contentful }) => ({
  ratingArea: Care?.ratingArea?.entity?.ratingArea,
  preCheckedProviders: Care?.memberCommsPrecheckedProviders?.entities || [],
  preCheckedProvidersBusy: Care?.memberCommsPrecheckedProviders?.busy || false,
  preCheckedProvidersError: Care?.memberCommsPrecheckedProviders?.error || null,
  specialtyFields:
    Contentful?.memberComms?.entities?.preCheckedProvidersCollection?.items ||
    [],
  contentfulBusy: Contentful?.memberComms?.busy || false,
  contentfulError: Contentful?.memberComms?.error || null,
})

const mapDispatchToProps = {
  fetchMemberCommsPrecheckedCategories,
  clearMemberCommsPrecheckedCategories,
  fetchMemberCommsPrecheckedProviders,
  clearMemberCommsPrecheckedProviders,
  setSelectedSpecialty,
}

export const PreCheckedProviders = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BasePreCheckedProviders)
